<wiz-vgroup #vgDetailZone width="100%" height="100%" 
 gap="2" padding="5px" class="section-container">
  
<wiz-hgroup width="100%" verticalAlign="center" padding="3px">
    <wiz-label #lbTitle width="100%" 
    [wizLabel]="titleLabel"
    class="smallTitleLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <!-- nom du champ et formule -->
  <wiz-vgroup #gpContent *ngIf="useContent" verticalAlign="center" height="45px" width="100%" class="section-container" padding="5px">
    <wiz-label #lbContent 
    [wizLabel]="contentLabel"
    width="100%" height="100%" padding="3px" class="listItemFont"></wiz-label>
  </wiz-vgroup> 

  <wiz-spacer height="20px"></wiz-spacer>

  <wiz-hgroup [width]="'100%'"> <!-- navbar -->
    <wiz-tab-bar #tabBar class="popBar" [width]="'100%'"
    [showNavigation]="false"
    [wizButtonList]="tabs"></wiz-tab-bar>
  </wiz-hgroup>



  <!-- entêtes -->
  <wiz-vgroup *ngIf="headTab" width="100%" height='100%' padding="5px" gap="10">  
    <!-- libellé & alignement -->
    <wiz-hgroup width="100%" gap="20">
      <wiz-vgroup>
        <wiz-text-input id="tiLabel"
        width="200px" 
        [wizLabel]="'$.common.label.$'" 
        [wizValue]="customHeaderTitle"
        [wizMaxChars]="50"> </wiz-text-input>

        <wiz-dropdown *ngIf="useCssStyle"
          #ddCssStyle
          width="150px"
          [wizLabelField]="'trsLabel'"
          [wizDataProvider] = "cssStyleDS"
          [wizLabel]="'$.pivot.edit.field.style.$'"></wiz-dropdown>  
      </wiz-vgroup>

      <!-- alignement -->  
      <wiz-dropdown *ngIf="useHeaderTextAlign" width="100px" 
      [wizLabelField]="'trsLabel'" 
      [wizDataProvider]="headerAlignDS"
      [wizLabel]="'$.common.text.align.$'"></wiz-dropdown>
      
      <wiz-vgroup gap="0">
        <wiz-checkbox id='cbHideFilter' *ngIf="useHeaderHideFilter" 
          [wizLabel]="'$.pivot.edit.filter.hidden.$'"
          [wizChecked]="hideFilter"
          ></wiz-checkbox>
        <wiz-checkbox id="cbExistValueFilter" 
          *ngIf="useHeaderOnlyExist"  
          [wizLabel]="'$.pivot.edit.filter.allvalues.$'"
          [wizChecked]="onlyExist"></wiz-checkbox>
        <wiz-checkbox #cbExport id="cbExport" 
          [wizLabel]="'$.widget.column.exportable.$'"
          [wizChecked]="exportable"
          style="padding-top: 15px;"
          ></wiz-checkbox>
      </wiz-vgroup>




    </wiz-hgroup>

    <!-- gestion du resize et de la taille des colonnes -->
    <wiz-hgroup #gpColumn wizValidationContainer 
      *ngIf="useColumn" width="100%" gap="20">
      <wiz-checkbox #cbColResize id="cbColResize" *ngIf="!isFilter" 
      [wizLabel]="'$.pivot.edit.column.rezisable.$'"
      [wizChecked]="colResize"
      style="padding-top: 15px;"
      ></wiz-checkbox>
      <wiz-numeric-input
        #niColWidth id="niColWidth"
        width="100px"
        wizMinNumber="0"
        wizMaxNumber="700"
        nbDecimal="0"
        [wizLabel]="'$.pivot.edit.column.size.$'"
        [wizNumber]="colWidth"
        wizValidator
        [wizShowErrors]="true"
      ></wiz-numeric-input>
      <wiz-numeric-input *ngIf="!isFilter"
        #niColMinWidth id="niColMinWidth"
        width="100px"
        wizMinNumber="0"
        wizMaxNumber="700"
        nbDecimal="0"
        [wizLabel]="'$.pivot.edit.column.minsize.$'"
        [wizNumber]="colMinWidth"
        [visible]="resizeEnabled"
      ></wiz-numeric-input>
      <wiz-checkbox #cbColAuto id="cbColAuto" *ngIf="!isFilter"
        [wizLabel]="'$.pivot.edit.column.auto.$'"
        [wizChecked]="colAuto"
        style="padding-top: 15px;"
        ></wiz-checkbox>
    </wiz-hgroup>
    
    <!-- groupe de colonnes d'appartenance -->  
     <wiz-hgroup>
        <wiz-dropdown *ngIf="useHeaderGroup && !isFilter" 
        width="250px" 
        [wizDataProvider]="groupDS"
        [wizLabelField]="'dropGroupLabel'" 
        [wizLabel]="'$.pivot.edit.field.groupmember.$'"></wiz-dropdown>
        <wiz-checkbox *ngIf="useHeaderInherit && useHeaderGroup && !isFilter" id="cbHeadInherit" 
          [wizLabel]="'$.header.style.inherit.$'"
          [wizChecked]="headInherit"
          style="padding-top: 15px;"
          ></wiz-checkbox>    
     </wiz-hgroup>


      <!-- couleurs d'entête -->  
    <wiz-hgroup #headerColors *ngIf="useHeaderColors" width="100%" >
        <wiz-vgroup width="110px">
          <wiz-label wizLabel="$.style.css.fontcolor.$" style="font-size: 11px; font-weight: bold;"></wiz-label>
          <wiz-hgroup>
            <span
              #blockFont
              [style.backgroundColor]="fontColor"
              style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
              width="20px"
              height="20px"
              (click)="showColorPicker($event)"
            ></span>
            <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockFont')">removal</wiz-icon>
          </wiz-hgroup>
        </wiz-vgroup>
        <wiz-vgroup width="110px">
          <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px; font-weight: bold;"></wiz-label>
          <wiz-hgroup>
            <span
              #blockBack
              [style.backgroundColor]="backgroundColor"
              width="20px"
              height="20px"
              (click)="showColorPicker($event)"
              style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
            ></span>
            <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
          </wiz-hgroup>
        </wiz-vgroup>

    </wiz-hgroup>

  </wiz-vgroup>


  <!-- gestion du format de données, du champ en cas de FD, et de la fonction d'aggregat -->
  <wiz-vgroup #gpFormat *ngIf="contentTab" 
  width="100%" height='100%' padding="5px" gap="10" class="section-container">
        <!-- readOnly -->
    <wiz-checkbox id="cbReadOnly" *ngIf="useFormatReadonly" 
    [wizLabel]="'$.measure.editable.$'"
    [wizChecked]="readOnly"
    ></wiz-checkbox> 
    <!-- $.pivot.edit.field.readonly.$ -->

    <wiz-hgroup width="100%" verticalAlign="center">
      <wiz-dropdown
        #ddFormat
        width="150px"
        [wizDataProvider]="formatDS"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.format.$'"></wiz-dropdown>
      <wiz-dropdown
        #ddField id="ddField" *ngIf="useFormatField"
        width="150px"
        [wizDataProvider] = "fieldDS"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.field.$'"></wiz-dropdown>
      <wiz-dropdown
        #ddSubField id="ddSubField" *ngIf="useFormatSubField"
        width="150px"
        [wizDataProvider] = "subFieldDS"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.subfield.$'"></wiz-dropdown>
      <!-- <wiz-dropdown 
        #ddChronoField *ngIf="useFormatChronoField" id="ddChronoField"
        width="150px"
        [wizDataProvider] = "chronoFieldDS"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.field.$'"></wiz-dropdown>
      <wiz-dropdown
        #ddFunc *ngIf="useFormatAggregate"
        width="150px"
        [wizDataProvider] = "functionDS"
        [wizLabelField]="'fullName'"
        [wizLabel]="'$.pivot.edit.field.agg.method.$'"
        wizMandatory="true"
        wizPanelWidth="250px"
      ></wiz-dropdown> -->
    </wiz-hgroup>
    <wiz-hgroup width="100%" *ngIf="!isFilter">
        <wiz-hgroup #cellColors width="100%" >
          <wiz-vgroup width="110px">
            <wiz-label wizLabel="$.style.css.fontcolor.$" style="font-size: 11px"></wiz-label>
            <wiz-hgroup>
              <span
                #cellBlockFont
                [style.backgroundColor]="cellFontColor"
                style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
                width="20px"
                height="20px"
                (click)="showColorPicker($event)"
              ></span>
              <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('cellBlockFont')">removal</wiz-icon>
            </wiz-hgroup>
          </wiz-vgroup>
          <wiz-vgroup width="110px">
            <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px"></wiz-label>
            <wiz-hgroup>
              <span
                #cellBlockBack
                [style.backgroundColor]="cellBackgroundColor"
                width="20px"
                height="20px"
                (click)="showColorPicker($event)"
                style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
              ></span>
              <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('cellBlockBack')">removal</wiz-icon>
            </wiz-hgroup>
          </wiz-vgroup>
        
          <!-- bold -->
        <wiz-checkbox id="cbBold"
        [wizLabel]="'$.style.css.bold.$'"
        [wizChecked]="isBold"></wiz-checkbox>

        </wiz-hgroup>
        
        <wiz-dropdown
          #ddStyle id="ddStyle"
          width="150px"
          [visible]="mayEditStyle"
          [wizDataProvider] = "styleDS"
          [wizLabelField]="'code'"
          [wizLabel]="'$.pivot.edit.field.condstyle.$'"></wiz-dropdown>

        <wiz-icon #btEditStyle 
        [visible]="editStyleEnabled"
        style="cursor: pointer; font-size: 20px; padding-bottom: 10px" (click)="editStyle()"
        >style</wiz-icon>
        <wiz-icon [visible]="mayEditStyle" style="cursor: pointer; font-size: 20px; padding-bottom: 10px" (click)="addStyle()"
        >creation</wiz-icon>

    </wiz-hgroup>
  </wiz-vgroup>

  <!-- gestion des champs visibles pour la sélection de FD -->
  <wiz-vgroup #gpFilterFields *ngIf="filterTab" 
  width="100%" height='100%' padding="5px" gap="10" class="section-container">
    <wiz-label [wizLabel]="'$.pivot.edit.field.fields.$'" class="smallTitleLabel"></wiz-label>
    <wiz-ag-grid #agGrid width="100%" height="100%" 
      class="ag-theme-alpine"
      [gridOptions]="gridOptions"
      [wizDatasource]="fieldsDS"
      [columnDefs]="columns"
      [wizRowSelection]="'multiple'"
      [dndConfig]="dndConfig"
      ></wiz-ag-grid>
  </wiz-vgroup>

  <!-- contenu avancé (settings sur workflow) -->
  <wiz-vgroup *ngIf="advancedTab" width="100%" height='100%' padding="5px" gap="10">    
      <wiz-text-area
        #taSettings id="taSettings"
        [wizLabel]="'$.mesure.settings.$'"
        [wizValue]="moreSettings"
        width="100%"
        height="100%"
        [wizMaxChars]="2000"
      ></wiz-text-area>
  </wiz-vgroup>



  <wiz-spacer  height="10px"></wiz-spacer>
  <wiz-hgroup  width="100%" height="45px" padding="5px" horizontalAlign="end" verticalAlign="center">
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      (click)="doCancel()"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
